import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefCustomers extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
  }

  getItemHtml(item, relatedMedia) {
    const { UrlName: resourcePath } = item;
    const imageFallback = 'https://d1l5pp53ux74mz.cloudfront.net/images/default-source/resources/customer_story-new.svg'; //<-- We can delete this if we dont need it.
    const { imageData } = super.setRelatedMedia(item, relatedMedia);
    const contentType = item.contenttype ? item.contenttype[0] : item.contenttypes[0]
    const pageUrl = super.getResourceUrl(contentType);
    const resourceUrl = `${pageUrl}/${resourcePath}`;

    const html = `
        <div class="col-4 -l-half">
            <div class="Card -h-scale">
                <div>
                    <img src="${imageData.Url || imageFallback}" class="-mb2 -mr1" alt="${imageData.AlternativeText}" title="${imageData.Title}"/>
                    <h3 class="h4">${this.encodeHtml(item.Title)}</h3>
                    <p class="-mb3">${this.encodeHtml(item.Summary)}</p>
                    <a href="${resourceUrl}" class="HoverBox -mta -i-next">${this.encodeHtml(item.CTAText)}</a>
                </div>
            </div>
        </div>
    `;

    return html;
  }
}
